"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("../../utils/styled-components"));
var ServiceHelp32 = function (props) { return (react_1.default.createElement("svg", __assign({ viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    react_1.default.createElement("path", { d: "M11.656 16.594v-4.281h-9.25q-.656 0-1.125.469t-.469 1.125v8.688q0 .656.469 1.125t1.125.469h.719q.156 0 .5.156t.344.75v1.438q0 .438.25.563t.594-.125l3.219-2.438.344-.172q.344-.172 1.031-.172h5.094q.656 0 1.125-.469t.469-1.125v-2.469h-.938q-1.438 0-2.469-1.031t-1.031-2.5zm-4 5.781q-.375 0-.609-.203t-.234-.547q0-.375.234-.578t.609-.203.609.203.234.578q0 .344-.234.547t-.609.203zm.5-2.5l-.031.188h-.938q-.063-.094-.094-.234t-.031-.297q0-1.125.906-1.453t.906-1.047q0-.344-.266-.547t-.703-.203-.844.188-.75.469l-.781-.906q.469-.438 1.094-.719t1.375-.281q1.125 0 1.766.531t.641 1.406q0 1.344-1.063 1.688t-1.188 1.219zm20.907-15H15.157q-.875 0-1.5.625T13.032 7v9.594q0 .875.625 1.5t1.5.625h5.656q.844 0 1.328.281t.484.281l3.688 2.781q.375.281.625.156t.25-.563V19.78q0-.656.344-.844t.563-.219h.969q.875 0 1.5-.625t.625-1.5V6.998q0-.875-.625-1.5t-1.5-.625zm-8 2.344h1.938v5.563h-1.938V7.219zm.968 9.125q-.594 0-.953-.328t-.359-.859q0-.594.359-.906t.953-.313.953.328.359.891q0 .531-.359.859t-.953.328z" }))); };
var StyledServiceHelp32 = styled_components_1.default(ServiceHelp32)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"], ["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"])), function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var stroke = _a.stroke;
    return stroke && "stroke: " + stroke + "; stroke-width: 64;";
});
exports.default = StyledServiceHelp32;
var templateObject_1;
//# sourceMappingURL=ServiceHelp32.js.map